import SummaryField from './SummaryField'
import { compose, lifecycle, withProps, withStateHandlers, withHandlers } from 'recompose'
import isEqual from 'lodash/isEqual'
import debounce from 'lodash/debounce'
import withScrollToAnchor from 'components/common/hoc/withScrollToAnchor'
import { WIDTH_DIFF_THRESHOLD } from './constants'

const withTooltipStateHandlers = withStateHandlers(
  {
    blockRef: '',
    infoRef: '',
    hasTooltip: false
  },
  {
    setInfoRef: state => ref => ({ ...state, infoRef: ref }),
    setBlockRef: state => ref => ({ ...state, blockRef: ref }),
    setTooltipState: ({ blockRef, infoRef }) => () => {
      let hasTooltip = false
      if (blockRef && infoRef) {
        const { width: blockWidth = 0 } = blockRef.getClientRects()[0] || {}
        const { width: infoRefWidth = 0 } = infoRef.getClientRects()[0] || {}
        hasTooltip = infoRefWidth + WIDTH_DIFF_THRESHOLD > blockWidth
      }
      return {
        hasTooltip
      }
    }
  })

const withTooltipHandlers = withHandlers({
  handleTooltipCalculations: ({ setTooltipState }) =>
    debounce(() => setTooltipState(), 100)
})

const withTooltipLifecycle = lifecycle({
  componentDidUpdate({ blockRef: prevBlockRef, infoRef: prevInfoRef, info: prevInfo }) {
    const { blockRef, infoRef, info, handleTooltipCalculations } = this.props
    if (blockRef && infoRef && info && (
      !isEqual(blockRef, prevBlockRef) ||
      !isEqual(infoRef, prevInfoRef) ||
      !isEqual(info, prevInfo))) {
      handleTooltipCalculations()
    }
  },
  componentDidMount() {
    const { handleTooltipCalculations } = this.props
    window.addEventListener('resize', handleTooltipCalculations)
    handleTooltipCalculations()
  },
  componentWillUnmount() {
    const { handleTooltipCalculations } = this.props
    window.removeEventListener('resize', handleTooltipCalculations)
  }
})

const withExtraProps = withProps(({ targetId, onClick, scrollToAnchorHandler }) => ({
  onClick: onClick || scrollToAnchorHandler,
  targetId: targetId || ''
}))

export default compose(
  withScrollToAnchor,
  withTooltipStateHandlers,
  withTooltipHandlers,
  withTooltipLifecycle,
  withExtraProps
)(SummaryField)
